import styles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image121 from './images/12-1.jpg';
import image171 from './images/17-1.jpg';
import image172 from './images/17-2.jpg';

export const InviteFriendDescription = () => {
    return (
        <div className={styles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>Заработок</b>
                </div>
                <ChallengeDetailHelpImage image={image121} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Зайдите в подраздел <b>«Пригласить друзей»</b>
                </div>
                <ChallengeDetailHelpImage image={image171} helpText='Это картинка. Ищите подраздел в разделе «Заработок».' />
            </p>

            <p>
                <div>
                    Разошлите своим друзьям и знакомым вашу реферальную ссылку, скопировав её или нажав кнопку <b>«Пригласить друга»</b>
                </div>
                <ChallengeDetailHelpImage image={image172} helpText='Это картинка. Ищите ссылку и кнопку в подразделе «Пригласить друзей».' />
            </p>
        </div>
    );
}